
import { z } from "zod";

export const workoutSchema = z.object({
  title: z.string().min(1, "O título é obrigatório"),
  description: z.string().optional(),
  type: z.string().min(1, "O tipo é obrigatório"),
  difficulty_level: z.string().min(1, "O nível de dificuldade é obrigatório"),
  duration: z.coerce.number().min(1, "A duração deve ser maior que 0"),
  equipment_needed: z.string().optional(),
  notes: z.string().optional(),
  days: z.number().min(1, "Mínimo 1 dia"),
  target_student_id: z.string().min(1, "Selecione um aluno"),
  day_titles: z.array(z.string()).optional()
});

export type WorkoutFormValues = z.infer<typeof workoutSchema>;
